import React from 'react'

export default () => (
  <div>
    <h4 className="title is-3">Planning for the Future</h4>
    <p>
      The Species Potential Habitat Tool (SPHT) is designed to help forest
      managers identify species or vegetation types that are suitable for
      specific sites given various climate change scenarios. With this
      information, forest managers can promote the transition of forests to
      species compositions that are better adapted to future climates.
    </p>
    <div>&nbsp;</div>
  </div>
)
